/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as l from "react";
import { useDir as i, classNames as a } from "@progress/kendo-react-common";
const c = "data-slider-label", s = (e) => {
  const t = l.useRef(null);
  return i(t), /* @__PURE__ */ l.createElement(
    "li",
    {
      ref: t,
      className: a("k-tick", { "k-tick-large": e.children, "k-first": e.firstTick, "k-last": e.lastTick }),
      title: e.title
    },
    e.children && /* @__PURE__ */ l.createElement(
      "span",
      {
        [c]: !0,
        className: "k-label",
        onClick: e.onClick
      },
      e.children
    )
  );
};
export {
  c as SLIDER_LABEL_ATTRIBUTE,
  s as SliderLabel
};
